module.exports = __webpack_public_path__ + "static/media/davi.b8830810.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/davi.png
// module id = 456
// module chunks = 0